export default __webpack_public_path__ + "static/media/remove@3x.87041419.png";